import { assetLoader } from './slices/assets/loader';
import accessors from './accessors';
import {
  interactivePause,
  interactiveResume,
  interactiveStart,
  objectConfig,
  updateTimer,
} from './actions/actions';
import { fetchHistory } from './slices/emoji/actions';
import getHistoryChunk from './slices/emoji/accessors';
import emojiSlice from './slices/emoji';

export default setupStoreListeners;

/**
 * Setup on store subscriber.
 * @param {import('redux').store} store
 */
function setupStoreListeners(store, { hostGateway }) {
  const { observers, listener } = store;

  if (false && process.env.NODE_ENV === 'development') {
    listener.startListening({
      matcher: () => true,
      effect(action) {
        console.debug(action.type);
      },
    });
  }

  /*
   * Internal watchers, handle planned/required actions
   */
  observers.add(
    accessors.assets.getRequired,
    function (listRequired, _, store) {
      if (listRequired.length === 0) {
        return;
      }

      // const assetList = getRequired();

      assetLoader(listRequired, store.dispatch);
    },
  );

  /*
   *  Exposes application state to host app
   */

  store.listener.startListening({
    actionCreator: interactiveStart,
    effect(action, api) {
      api.dispatch(objectConfig(action.payload));
    },
  });

  store.listener.startListening({
    actionCreator: interactivePause,
    effect(action, api) {
      hostGateway.sendNotify.paused();
    },
  });

  store.listener.startListening({
    actionCreator: interactiveResume,
    effect(action, api) {
      hostGateway.sendNotify.resumed();
    },
  });

  store.listener.startListening({
    actionCreator: updateTimer,
    effect(action, api) {
      /* это полный бред запускать его на каждом тике*/
      // api.dispatch(fetchEventsHistory(action));

      /*
        Dispatch fetchHistory action, if emoji enabled
       */
      api.dispatch(fetchHistory(action.payload));

      /*
      Dispatch pushToQueue action, e.g. display emoji
       */
      api.dispatch((dispatch, getState) => {
        const state = getState();
        if (!state.emoji.enabled) {
          return;
        }
        let chunk = getHistoryChunk(state, action.payload.position);
        if (!chunk) {
          return;
        }
        if (!chunk.results) {
          return;
        }

        const emojiQueue = chunk.results.filter(
          ({ start_time }) => start_time === action.payload.position,
        );
        if (emojiQueue.length > 0) {
          dispatch(emojiSlice.actions.pushToQueue(emojiQueue));
        }
      });
    },
  });
}
